import { catalogApiFetch } from '../admin/jscontrol/apiClient';
import { parseApiList } from './productStorefront';

/** Resolve ProductVariantId for AddToCart (tries API, falls back to ProductId). */
export async function resolveProductVariantId(productId) {
  const id = Number(productId);
  if (!Number.isFinite(id) || id <= 0) return null;

  for (const endpoint of [
    `/ProductVariant/GetByProductId/${id}`,
    `/ProductVariant/GetDefault/${id}`,
  ]) {
    try {
      const { data } = await catalogApiFetch(endpoint);
      const items = parseApiList(data);
      const row = items[0] || data?.data || data;
      const variantId = row?.ProductVariantId ?? row?.productVariantId;
      if (variantId) return Number(variantId);
    } catch {
      /* try next endpoint */
    }
  }

  try {
    const { data } = await catalogApiFetch(`/Product/GetById/${id}`);
    const p = data?.data ?? data;
    const variantId =
      p?.ProductVariantId ?? p?.productVariantId ??
      p?.DefaultProductVariantId ?? p?.defaultProductVariantId;
    if (variantId) return Number(variantId);
  } catch {
    /* use product id as variant */
  }

  return id;
}

export async function resolveProductIdFromVariant(productVariantId) {
  try {
    const { data } = await catalogApiFetch(`/ProductVariant/GetById/${productVariantId}`);
    const v = data?.data ?? data;
    const productId = v?.ProductId ?? v?.productId;
    if (productId) return Number(productId);
  } catch {
    /* variant id may equal product id */
  }
  return Number(productVariantId);
}
